const en = {
  entry: {
    default:'This site is using the default checkout.',
    configured: 'This site has configured a custom checkout.',
    edit: 'Edit checkout style',
    copy: 'Copy checkout style',
    copyWhat: "Which site would you like to copy the current site's checkout to? The copied checkout will take effect after your confirmation.",
    webSite: 'Website',
  },
  settings: {
    title: 'Custom Checkout',
    reset: 'Restore default style',
    save: 'Save and apply',
    tip: 'Use specific custom styles to make the checkout look more suitable for your site.',
    tabInfo: 'Browser Tab Information',
    tabTitle: 'Tab Title',
    browserTabIconUrl: 'Tab Icon',
    brand: 'Brand',
    themeType: 'Appearance Style',
    layoutType: 'Display Settings',
    layoutStyle: 'Payment method Layout Style',
    tab: 'Tabbed Layout',
    accordion: 'Vertical Layout',
    text: 'Text',
    light: 'Light',
    dark: 'Dark',
    headerBg: 'Title Bar Background Color',
    cashierLogo: 'Brand Logo',
    cashierLogoPosition: 'Logo Position',
    headerText: 'Title Bar Text',
    themeColor: 'Brand Accent Color',
    languages: 'Supported Languages',
    langTips: 'The preview on the right shows English, but the actual result will be based on your selection.',
    all: 'All',
    formStyle: 'Form Style',
    prompt: 'Prompts',
    font: 'Font',
    default: 'Default',
    shape: 'Component Shape',
    round: 'Corner Radius Size',
    size: 'Component Size',
    spacing: 'Component Spacing',
    fontSize: 'Font Size',
    showReturn: 'Show Return Entry',
    showCardsLogo: 'Show Cards Logo',
    returnText: 'Return Text',
    returnPosition: 'Position',
    showPCI: 'Show Security Assurance',
    roundedRectangle: 'Rounded Rectangle',
    squareRectangle: 'Square Rectangle',
    fullyRounded: 'Full Rounded',
    small: 'Small Size',
    medium: 'Medium Size',
    large: 'Large Size',
    left: 'Left',
    center: 'Center',
    right: 'Right',
    orderInfo: 'Order Information Display',
    showOrderId: 'Show Order ID',
    showOrderAmount: 'Show Order Amount',
    showBilling: 'Show Billing Address',
    resultPage: 'Result Prompt Page',
    toPingPongResult: 'Display the "payment completion page" provided by PingPong',
    resultAutoRedirect: 'Automatic redirect after displaying the "payment completion page"',
    resultAutoRedirectTime: 'Duration of stay on the "payment completion page"(Default 3s)',
    preview: 'Preview',
    redirect: 'Redirect to Checkout',
    embed: 'Embed Checkout',
    embedTip: 'Note: Embedded checkout only involves partial configuration content',
    embedLangTip: 'Note: Embedded checkout language follows your webpage, default is English',
    mobileTip: 'Note: The mobile cashier only involves partial configuration content',
    cancelEdit: 'Confirm to discard changes?',
    confirmLeave: 'Your modifications have not been saved and applied. Are you sure you want to leave the page? Leaving the page will cause the modified content to be lost.',
    confirmLeave2: 'Are you sure you want to leave this page?',
    saveSuccess: 'Successfully!',
    saveFailed: 'Failed to save, please try again.',
    confirmDefault: 'Are you sure you want to restore default settings?',
    tips: 'Tip',
    notSupport: 'The embedded checkout of website e-commerce platforms such as Shopify and Shopline do not support this function.'
  },
  upload: {
    imageSize: 'Image Size',
    recommendFormat: 'Recommended Format',
    fileSize: 'File Size',
    uploadFailed: 'Upload failed',
    formatError: 'Image format error',
    formatTip: 'Image should be in JPG, JPEG, PNG, BMP, SVG or ICO format',
    attention: 'Attention',
    uploadTip: '10KB or less',
    uploadTip2: '32x32 pixels',
    sizeError: 'Image dimension error',
    sizeTip: 'Image dimensions must be {size} pixels',
    failed: 'Failed',
    loadFailed: 'Unable to load image, please try again',
    readField: 'Unable to read file, please try again',
    clear: 'Clear',
  },
  button: {
    continue: 'Continue editing',
    discard: 'Discard changes',
    confirm: 'Confirm',
    cancel: 'Cancel'
  }
}

export default en
